import { render, staticRenderFns } from "./PackageCategoryList.vue?vue&type=template&id=5ac48d5b&scoped=true"
import script from "./PackageCategoryList.vue?vue&type=script&lang=js"
export * from "./PackageCategoryList.vue?vue&type=script&lang=js"
import style0 from "./PackageCategoryList.vue?vue&type=style&index=0&id=5ac48d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac48d5b",
  null
  
)

export default component.exports